// Header disclosures: services mega menu, help and user dropdowns, mobile menu.
// Each trigger has data-toggle="<panel id>" and aria-expanded.
export default function initMenus(root) {
  const triggers = Array.from(root.querySelectorAll("[data-toggle]"))

  const setOpen = (trigger, open) => {
    const panel = document.getElementById(trigger.dataset.toggle)
    if (!panel) return
    trigger.setAttribute("aria-expanded", String(open))
    panel.hidden = !open
    if (trigger.dataset.toggle === "hv-mmenu") document.body.classList.toggle("hv-noscroll", open)
  }

  const closeAll = (except) => {
    triggers.forEach((trigger) => {
      if (trigger !== except && trigger.getAttribute("aria-expanded") === "true") setOpen(trigger, false)
    })
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.stopPropagation()
      const open = trigger.getAttribute("aria-expanded") !== "true"
      closeAll(trigger)
      setOpen(trigger, open)
    })
  })

  document.addEventListener("click", (event) => {
    const insidePanel = triggers.some((trigger) => {
      const panel = document.getElementById(trigger.dataset.toggle)
      return panel && panel.contains(event.target)
    })
    if (!insidePanel) closeAll()
  })

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return
    const open = triggers.find((trigger) => trigger.getAttribute("aria-expanded") === "true")
    if (open) {
      setOpen(open, false)
      open.focus()
    }
  })

  // Links inside the mobile menu that point to this page should close it.
  const mobileMenu = document.getElementById("hv-mmenu")
  if (mobileMenu) {
    mobileMenu.addEventListener("click", (event) => {
      const link = event.target.closest('a[href^="#"]')
      if (link) closeAll()
    })
  }
}
